import { AbstractDataMask } from "@bytereplay/core";
class CensoredDataMask extends AbstractDataMask {
  constructor() {
    super(/^.*$/, "*");
  }
  maskSubstring(text, maskingCharacter) {
    if (text.match(/(\d{1,2} [a-zA-Z]{3}, \d{4})|([a-zA-Z]{3} \d{1,2}, \d{4})/)) {
      return text;
    }
    const windowStarlingStore = window.__I18NSPECT_REVERSE_INDEX__;
    if (windowStarlingStore) {
      if (windowStarlingStore[text]) {
        return text;
      } else {
        return text.replace(/./g, maskingCharacter);
      }
    } else {
      return text.replace(/\d/g, maskingCharacter);
    }
  }
}
var mask_default = CensoredDataMask;
export {
  mask_default as default
};
